<template>
    <div class="list-wrap">
        <div class="body">
            <flow-entity-editor
                v-if="isEditMode"
                @back="onBack"
            />
            <div
                v-else
                class="manager-wrap"
            >
                <p class="sidebar-helptext">
                  {{ $t('model.nlu-model.sidebar.flow_entities.flow_entities_manager.flowEntitiesAllow') }}
                </p>
                <or-button
                    class="flat add-btn"
                    type="secondary"
                    icon="add"
                    size="small"
                    color="primary"
                    @click="createNewHandler"
                >
                  {{ $t('model.nlu-model.sidebar.flow_entities.flow_entities_manager.createNew') }}
                </or-button>
                <div class="list-wrap">
                    <flow-entity-item
                        v-for="entity in sortedFlowEntities"
                        :key="entity.id"
                        :flow-entity="entity"
                        @edit="onEdit"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import KnowledgeBus from '@/KnowledgeBus'
import flowEntityItem from './flow_entity_item'
import flowEntityEditor from './flow_entity_editor'

export default {
  components: { flowEntityItem, flowEntityEditor },

  computed: {
    ...mapState('knowledgebase/entities', ['postprocessEnities']),

    sortedFlowEntities () {
      return _.sortBy(this.postprocessEnities.value, ['name'])
    }
  },

  data () {
    return {
      isEditMode: false
    }
  },

  methods: {
    createNewHandler () {
      this.isEditMode = true
    },

    onEdit (flowEntity) {
      this.isEditMode = true
      this.$nextTick(() => {
        KnowledgeBus.$emit('temp-flow-entity::set', flowEntity)
      })
    },

    onBack () {
      this.isEditMode = false
    }
  }
}
</script>

<style lang="scss" scoped>
    .list-wrap {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow-y: scroll;

        .body {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            max-height: 100%;
            overflow: hidden;
            align-items: flex-start;

            .manager-wrap {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                height: 100%;
                padding: 16px 0 16px;

                .sidebar-helptext {
                    padding: 0 $sp-3;
                }
            }

            .add-btn {
                padding: 0;
                padding-left: $sp-3;
                margin-bottom: $sp-2;
                color: $or-blue;
            }
        }
    }
</style>
